import Alert from '@mui/material/Alert'

const LoadingMessage = ({ heroCount, hasLoaded, isLoading, message }) => {
    const textToDisplay = isLoading ? message : hasLoaded && !heroCount ? 'No Heroes Found' : null
    return textToDisplay ? (
        <Alert variant="outlined" severity="success" className="loading-message">
            {textToDisplay}
        </Alert>
    ) : null
}

export default LoadingMessage
